import { GetAccountGroupsApi } from "@/features/accounts/account-group/services/get-account-groups-api";
import { GetAccountGroupsRequestModel } from "@/features/accounts/account-group/services/get-account-groups-model";

/// 口座グループ一覧取得
export class GetAccountGroupsService {
  private getAccountGroupsApi = new GetAccountGroupsApi();

  /**
   * 口座グループ一覧取得
   */
  public async getAccountGroups(param: GetAccountGroupsRequestModel) {
    return await this.getAccountGroupsApi.getAccountGroups(param);
  }
}

